import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MaterialTextField from '@material-ui/core/TextField';
import styles from './TextField.scss';

const TextField = ({
    className,
    hasError,
    errorText,
    isEmpty,
    ...props
}) =>
    <MaterialTextField
        helperText={errorText}
        variant='outlined'
        InputProps={{
            className: classnames(
                styles.base,
                className,
                {
                    [styles.hasError]: hasError,
                    [styles.empty]: isEmpty
                }
            )
        }}
        InputLabelProps={{
            shrink: true
        }}
        { ...props }
    />;

TextField.propTypes = {
    className: PropTypes.string,
    hasError: PropTypes.bool,
    errorText: PropTypes.string,
    isEmpty: PropTypes.bool
};

TextField.defaultProps = {
    className: '',
    hasError: false,
    isEmpty: false,
    errorText: ''
};

export default TextField;
